import { motion } from "framer-motion";
import { Building2 } from "lucide-react";
import { useLanguage } from "../LanguageContext";
import { translations } from "../translations";

const fadeIn = {
  hidden: { opacity: 0, y: 50 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.8 } },
};

const DeveloperInfoCard = () => {
  const { language } = useLanguage();
  const developerInfo = translations[language].developerInfo;

  return (
    <motion.div
    className="mt-6 md:mt-8 border border-gray-300 rounded-lg p-4 sm:p-6 shadow-md max-w-full mx-auto"
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true }}
    variants={fadeIn}
  >
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
      {developerInfo.developers.map((developer, index) => (
        <div key={index} className="flex items-start gap-3 sm:gap-4">
          <img
            src={developer.avatar}
            alt={`${developer.name} avatar`}
            className="w-12 h-12 sm:w-16 sm:h-16 rounded-full object-cover flex-shrink-0"
          />
          <div className="text-xs sm:text-sm md:text-base text-gray-700">
            <p>
              <strong>{developer.name}</strong>
            </p>
            <p>
              {developer.title}
            </p>
          </div>
        </div>
      ))}
      <div className="col-span-1 sm:col-span-2">
        <p className="text-xs sm:text-sm md:text-base text-gray-700">
          <strong>{developerInfo.addressLabel}: </strong>{developerInfo.address}
        </p>
      </div>
    </div>
  </motion.div>
  );
};

export default DeveloperInfoCard;